import { Entity } from '@backstage/catalog-model';

/**
 * Résout le namespace Kubernetes d'un composant pour un environnement donné.
 *
 * Par défaut on utilise le namespace global défini dans
 * `platform.environments[].namespace` (ex. `espace-formalite-prod`), qui suppose que
 * tous les composants vivent dans les namespaces de l'app principale.
 *
 * Un composant déployé dans ses propres namespaces (ex. `espace-formalite-agent`, dont
 * les pods tournent dans `espace-formalite-agent-prod` / `espace-formalite-agent-preprod`)
 * peut surcharger ce comportement via l'annotation
 * `platform.io/namespace-template` : sa valeur doit contenir le placeholder
 * `{env}`, remplacé par la clé d'environnement (`prod`, `preprod`…).
 *
 * Exemple : `platform.io/namespace-template: espace-formalite-agent-{env}`
 *   → env `prod`    → `espace-formalite-agent-prod`
 *   → env `preprod` → `espace-formalite-agent-preprod`
 */
export function resolveNamespace(
  entity: Entity,
  envKey: string,
  configuredNamespace: string | undefined,
): string {
  const template =
    entity.metadata.annotations?.['platform.io/namespace-template'];
  if (template && template.includes('{env}')) {
    return template.replace(/\{env\}/g, envKey);
  }
  return configuredNamespace ?? 'default';
}
